export const enum Booleans {
  True = 'DV-BOOLEAN#0',
  False = 'DV-BOOLEAN#1',
}

export const DV_BOOLEAN = {
  id: 'DV-BOOLEAN',
  description: {
    fr: 'True',
    en: 'False',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'true',
        en: 'true',
      },
    },
    {
      id: '1',
      value: {
        fr: 'false',
        en: 'false',
      },
    },
  ],
};
